import React, { memo } from 'react';

import { DynamicIconWrapper, Icons, SpinnerOverlay } from '@components/common';

import StatusListCount from './StatusListCount';

import styles from './StatisticList.module.scss';

interface IStatisticItem {
	title: string;
	value: number;
	unit?: string;
}

interface IStatisticList {
	title: string;
	total: number;
	items: IStatisticItem[];
	isLoading?: boolean;
	onClick?: () => void;
	tooltipLabel?: string;
	isWithViewIcon?: boolean;
}

const StatisticList = ({
	title,
	total,
	items,
	isLoading,
	onClick,
	isWithViewIcon,
	tooltipLabel,
}: IStatisticList) => {
	return (
		<div className={styles.wrapper}>
			{isLoading && <SpinnerOverlay />}
			<div className={styles.titleWrapper}>
				<div className={styles.title}>
					{title}
					{isWithViewIcon && (
						<DynamicIconWrapper
							icon={Icons.viewIcon}
							onClick={onClick}
							tooltipLabel={tooltipLabel}
						/>
					)}
				</div>
				<StatusListCount
					count={total}
					isTotal
				/>
			</div>
			{items.map((item) => (
				<div
					key={item.title}
					className={styles.itemWrapper}
				>
					<div className={styles.itemTitle}>{item.title}</div>
					<StatusListCount
						count={item.value}
						unit={item.unit}
					/>
				</div>
			))}
		</div>
	);
};

export default memo(StatisticList);
